import { render, staticRenderFns } from "./LaboratoriesResults.vue?vue&type=template&id=d62cd134"
import script from "./LaboratoriesResults.vue?vue&type=script&lang=js"
export * from "./LaboratoriesResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports